import React from "react";
import { Link } from "react-router-dom";

function InfluenceHero() {
  return (
    <div
      id="khalif-breadcrumb-wrap"
      className="khalif-breadcrumb-wrap breadcrumb-bg text-center d-flex align-items-center avatar"
      style={{ backgroundImage: `url('/assets/img/infbg.jpg')` }}
    >
      <div className="container">
        <div className="row">
          <div className="offset-xl-2 col-xl-8">
            <div className="khalif-breadcrumb-content">
              <h2>Digital Marketing</h2>
              <ul className="breadcrumb justify-content-center">
                <li className="breadcrumb-item">
                  <Link to="/" title="Home">
                    Home /
                  </Link>
                </li>
                <li className="breadcrumb-item active">Digital Marketing</li>
              </ul>
              <p>
                We work with a top-notch team of influential social media stars
                and offer exceptional influencer marketing, complete with our
                extensive database and customized campaigns
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfluenceHero;
